// Mobile-web app-install sheet (plans/publisher-web-app-install-prompt.md).
// The core bundle only loads the sheet bundle (prompt.js) on phone article
// pages; that bundle counts visits and decides whether to show the sheet.
const BUNDLE_PATH = require('./bundlePath');
const { phonePlatform } = require('./platform');
const { loadScript } = require('../scriptLoader');
const { getBrandConfig } = require('../../brandConfigs');
const { resolveBrandContext } = require('../utils/brandContext');
const { detectDevice } = require('../deviceDetection');
const { isSponsoredContent, isStaticPage, isEnabledFlag } = require('../insights/pageContext');
const { isAutomatedClient, isPrerendering, isSameSiteWithIssuer, isTopLevelContext } = require('../identity/context');

let installed = false;

function start({ brand, issuer, isArticle }) {
  if (!isArticle || !isTopLevelContext() || !isSameSiteWithIssuer(issuer) || isPrerendering() || isAutomatedClient()) return;
  const brandConfig = getBrandConfig(brand);
  const platform = phonePlatform(navigator.userAgent);
  if (!brandConfig.appInstall || !platform || detectDevice() !== 'mobile') return;
  if (isSponsoredContent(window) || isEnabledFlag(window._noads) || isEnabledFlag(window._urlonly)) return;
  if (isStaticPage({ staticPagesSectionId: brandConfig.staticPagesSectionId, post_sections: window.post_sections })) return;
  const origin = new URL(issuer).origin;
  const force = new URLSearchParams(window.location.search).get('milla_app_prompt') === 'force';
  loadScript(`${origin}${BUNDLE_PATH}`)
    .then(() => window.MillaAppPrompt.run({
      brand, origin, platform, force, language: resolveBrandContext().language, appInstall: brandConfig.appInstall
    }))
    .catch(() => { /* never surface */ });
}

/**
 * Runs once per page after the DOM is ready (the RebelMouse page globals are
 * set by then). `isArticle` is called at that point.
 */
function setupAppPrompt({ brand, issuer, isArticle }) {
  if (installed || typeof window === 'undefined' || typeof document === 'undefined') return;
  installed = true;
  const run = () => { try { start({ brand, issuer, isArticle: isArticle() }); } catch (_) { /* never surface */ } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
}

module.exports = { setupAppPrompt };
